(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /*
    <laddu-motion> : Imperaire "Royal Roll of 4 Healthy Laddus"
    A 15 second, code-drawn 3D-style product film that loops inside the hero.

      0 - 3s    Grand entrance: golden spotlights, floating dust, the sesame laddu rolls in
      3 - 8s    Four flavours, one journey: Sesame, Ragi, Badam, Pulse roll in single file
      8 - 12s   Hero moment: the queue slows onto a gold platform, light sweeps across
      12 - 15s  Brand reveal: slow push-in, "Imperaire", tagline, ingredient line, shimmer

    The four laddus move as one evenly spaced queue (19 units apart, 14 units wide),
    so they can never touch. Everything is driven from a single timeline function
    (render(t)), which keeps visuals and the optional synthesised sound in sync.
  */
  (function () {
    if (!window.customElements || customElements.get('laddu-motion')) return;

    var TAU = Math.PI * 2;
    var DEG = 180 / Math.PI;
    var DURATION = 15; // length of the film in seconds
    var HOLD = 1.6; // seconds the final frame stays up before the loop restarts
    var FADE = 0.7; // fade to black before the loop restarts
    var CYCLE = DURATION + HOLD + FADE;

    /* ---------- small helpers ---------- */

    function rng(seed) {
      var s = seed >>> 0;
      return function () {
        s = (s + 0x6d2b79f5) >>> 0;
        var t = s;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
    }

    function gauss(r) {
      return Math.sqrt(-2 * Math.log(r() + 1e-9)) * Math.cos(TAU * r());
    }

    function clamp(v, a, b) {
      return Math.min(b, Math.max(a, v));
    }

    function smooth(a, b, x) {
      var t = clamp((x - a) / (b - a), 0, 1);
      return t * t * (3 - 2 * t);
    }

    function pick(r, list) {
      return list[Math.floor(r() * list.length) % list.length];
    }

    function f1(v) {
      return v.toFixed(1);
    }

    /* Monotone cubic interpolation (Fritsch-Carlson): smooth, never overshoots. */
    function makeSpline(pts) {
      var n = pts.length;
      var xs = pts.map(function (p) {
        return p[0];
      });
      var ys = pts.map(function (p) {
        return p[1];
      });
      var d = [];
      var m = [];
      var i;
      for (i = 0; i < n - 1; i++) d[i] = (ys[i + 1] - ys[i]) / (xs[i + 1] - xs[i]);
      m[0] = 0;
      m[n - 1] = 0;
      for (i = 1; i < n - 1; i++) m[i] = d[i - 1] * d[i] <= 0 ? 0 : (d[i - 1] + d[i]) / 2;
      for (i = 0; i < n - 1; i++) {
        if (d[i] === 0) {
          m[i] = 0;
          m[i + 1] = 0;
        } else {
          var a = m[i] / d[i];
          var b = m[i + 1] / d[i];
          var s = a * a + b * b;
          if (s > 9) {
            var k = 3 / Math.sqrt(s);
            m[i] = k * a * d[i];
            m[i + 1] = k * b * d[i];
          }
        }
      }
      return function (x) {
        if (x <= xs[0]) return ys[0];
        if (x >= xs[n - 1]) return ys[n - 1];
        var j = 0;
        while (x > xs[j + 1]) j++;
        var h = xs[j + 1] - xs[j];
        var t = (x - xs[j]) / h;
        var t2 = t * t;
        var t3 = t2 * t;
        return (
          (2 * t3 - 3 * t2 + 1) * ys[j] +
          (t3 - 2 * t2 + t) * h * m[j] +
          (-2 * t3 + 3 * t2) * ys[j + 1] +
          (t3 - t2) * h * m[j + 1]
        );
      };
    }

    /* ---------- laddu look: one palette per variety (fixed order) ---------- */

    var VARIETIES = [
      {
        id: 'sesame',
        base: ['#33261a', '#18120c', '#0a0705'],
        sets: [
          { n: 150, kind: 'seed', w: [2.4, 4.6], colors: ['#0c0907', '#14100b'] },
          { n: 120, kind: 'seed', w: [2.4, 4.4], colors: ['#d7ab55', '#c99a43', '#e3bd70'] },
          { n: 40, kind: 'seed', w: [2.4, 4.2], colors: ['#f0e0b8', '#f6ebcd'] }
        ],
        particle: { n: 16, cls: 'hp--seed', colors: ['#f0e0b8', '#d7ab55', '#c99a43'] }
      },
      {
        id: 'ragi',
        base: ['#93502f', '#6c3521', '#3d1b0f'],
        sets: [
          { n: 40, kind: 'lump', w: [5, 9], colors: ['#9c5937', '#6b341f', '#84452a'] },
          { n: 520, kind: 'grain', w: [1.1, 2.7], colors: ['#a9663f', '#7a3b24', '#c07a4c', '#4a2213', '#8f4d2f'] }
        ],
        particle: { n: 9, cls: 'hp--flour', colors: [] }
      },
      {
        id: 'badam',
        base: ['#ecc58b', '#d3a366', '#9c6e3a'],
        sets: [
          { n: 150, kind: 'grain', w: [1, 2.6], colors: ['#b98448', '#f1d9a6', '#8d5f2e'] },
          { n: 38, kind: 'shard', w: [8, 15], colors: ['#f3e0b8', '#ead2a0', '#e0c18a'] }
        ],
        particle: { n: 9, cls: 'hp--flake', colors: [] }
      },
      {
        id: 'pulse',
        base: ['#c4813a', '#9c6023', '#5e3512'],
        sets: [
          { n: 170, kind: 'grain', w: [1, 2.4], colors: ['#d49a4a', '#7a4a1c', '#e8bf72'] },
          { n: 72, kind: 'lentil', w: [3.4, 6.4], colors: ['#e6b73f', '#d77c2b', '#8a9a3d', '#efdba4', '#a8512a'] }
        ],
        particle: { n: 11, cls: 'hp--lentil', colors: ['#e6b73f', '#d77c2b', '#8a9a3d', '#efdba4'] }
      }
    ];

    function itemSVG(kind, c, w, r) {
      var h;
      switch (kind) {
        case 'seed':
          h = w * 0.55;
          return (
            '<ellipse rx="' + f1(w) + '" ry="' + f1(h) + '" fill="' + c + '"/>' +
            '<ellipse cx="' + f1(-w * 0.25) + '" cy="' + f1(-h * 0.3) + '" rx="' + f1(w * 0.45) + '" ry="' + f1(h * 0.28) + '" fill="rgba(255,255,255,.28)"/>'
          );
        case 'lump':
          h = w * (0.6 + r() * 0.3);
          return '<ellipse rx="' + f1(w) + '" ry="' + f1(h) + '" fill="' + c + '" opacity=".75"/>';
        case 'grain':
          return (
            '<circle r="' + f1(w) + '" fill="' + c + '"/>' +
            '<circle cx="' + f1(-w * 0.3) + '" cy="' + f1(-w * 0.3) + '" r="' + f1(w * 0.35) + '" fill="rgba(255,240,210,.25)"/>'
          );
        case 'shard':
          h = w * (0.34 + r() * 0.14);
          return (
            '<path d="M' + f1(-w) + ' 0 Q0 ' + f1(-h * 1.5) + ' ' + f1(w) + ' 0 Q0 ' + f1(h * 1.5) + ' ' + f1(-w) + ' 0Z" fill="' + c + '" stroke="#9a6d36" stroke-width=".9"/>' +
            '<path d="M' + f1(-w * 0.7) + ' 0 Q0 ' + f1(-h * 0.5) + ' ' + f1(w * 0.7) + ' 0" fill="none" stroke="rgba(154,109,54,.55)" stroke-width=".6"/>'
          );
        default:
          // lentil / pulse
          h = w * 0.8;
          return (
            '<ellipse rx="' + f1(w) + '" ry="' + f1(h) + '" fill="' + c + '"/>' +
            '<path d="M' + f1(-w * 0.7) + ' 0 L' + f1(w * 0.7) + ' 0" stroke="rgba(0,0,0,.28)" stroke-width=".7"/>' +
            '<ellipse cx="' + f1(-w * 0.3) + '" cy="' + f1(-h * 0.35) + '" rx="' + f1(w * 0.4) + '" ry="' + f1(h * 0.25) + '" fill="rgba(255,255,255,.25)"/>'
          );
      }
    }

    /*
      A rolling ball seen from the side spins about the viewing axis, so its visible
      hemisphere only ever rotates in-plane. We scatter texture on that hemisphere in
      3D, foreshorten it toward the rim (scale along the radial direction by z) and
      then let the whole layer rotate: a believable round, textured laddu.
    */
    function sphereSVG(v, uid, idx) {
      var r = rng(7919 * (idx + 3));
      var gid = 'hlg-' + uid + '-' + idx;
      var fa = 'hla-' + uid + '-' + idx;
      var fb = 'hlb-' + uid + '-' + idx;
      var items = '';
      v.sets.forEach(function (set) {
        for (var k = 0; k < set.n; k++) {
          var x = gauss(r);
          var y = gauss(r);
          var z = Math.abs(gauss(r));
          var len = Math.sqrt(x * x + y * y + z * z) || 1;
          x /= len;
          y /= len;
          z /= len;
          var w = set.w[0] + r() * (set.w[1] - set.w[0]);
          var c = pick(r, set.colors);
          items +=
            '<g transform="translate(' + f1(x * 93) + ' ' + f1(y * 93) + ') rotate(' + Math.round(Math.atan2(y, x) * DEG) +
            ') scale(' + Math.max(0.22, z).toFixed(2) + ' 1) rotate(' + Math.round(r() * 180) + ')">' +
            itemSVG(set.kind, c, w, r) + '</g>';
        }
      });
      return (
        '<svg viewBox="-100 -100 200 200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
        '<defs>' +
        '<radialGradient id="' + gid + '" cx=".36" cy=".32" r=".9">' +
        '<stop offset="0" stop-color="' + v.base[0] + '"/><stop offset=".55" stop-color="' + v.base[1] + '"/><stop offset="1" stop-color="' + v.base[2] + '"/>' +
        '</radialGradient>' +
        '<filter id="' + fa + '" x="0" y="0" width="100%" height="100%">' +
        '<feTurbulence type="fractalNoise" baseFrequency=".85" numOctaves="2" seed="' + (idx + 3) + '"/>' +
        '<feColorMatrix values="0 0 0 0 .05  0 0 0 0 .03  0 0 0 0 .01  0 0 0 1.25 -.42"/></filter>' +
        '<filter id="' + fb + '" x="0" y="0" width="100%" height="100%">' +
        '<feTurbulence type="fractalNoise" baseFrequency=".7" numOctaves="2" seed="' + (idx + 11) + '"/>' +
        '<feColorMatrix values="0 0 0 0 1  0 0 0 0 .86  0 0 0 0 .6  0 0 0 1.3 -.64"/></filter>' +
        '</defs>' +
        '<circle r="100" fill="url(#' + gid + ')"/>' +
        '<rect x="-100" y="-100" width="200" height="200" filter="url(#' + fa + ')" opacity=".6"/>' +
        '<g>' + items + '</g>' +
        '<rect x="-100" y="-100" width="200" height="200" filter="url(#' + fb + ')" opacity=".32"/>' +
        '</svg>'
      );
    }

    /* ---------- optional synthesised sound (starts only when the viewer taps the button) ---------- */

    function Sfx() {
      this.ctx = null;
      this.on = false;
      this.live = [];
    }

    Sfx.prototype.enable = function () {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return Promise.resolve(false);
      var self = this;
      if (!this.ctx) {
        this.ctx = new AC();
        this.master = this.ctx.createGain();
        this.master.gain.value = 0.55;
        this.master.connect(this.ctx.destination);
        var len = this.ctx.sampleRate * 2;
        this.buf = this.ctx.createBuffer(1, len, this.ctx.sampleRate);
        var d = this.buf.getChannelData(0);
        for (var i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
      }
      return this.ctx.resume().then(function () {
        self.on = true;
        return true;
      });
    };

    Sfx.prototype.disable = function () {
      this.on = false;
      this.stop();
    };

    Sfx.prototype.stop = function () {
      this.live.forEach(function (n) {
        try {
          n.stop();
        } catch (e) {
          /* already stopped */
        }
      });
      this.live = [];
    };

    Sfx.prototype.suspend = function (flag) {
      if (!this.ctx || !this.on) return;
      if (flag) this.ctx.suspend();
      else this.ctx.resume();
    };

    Sfx.prototype.noise = function (loop) {
      var s = this.ctx.createBufferSource();
      s.buffer = this.buf;
      s.loop = !!loop;
      this.live.push(s);
      return s;
    };

    Sfx.prototype.osc = function (type, freq) {
      var o = this.ctx.createOscillator();
      o.type = type;
      o.frequency.value = freq;
      this.live.push(o);
      return o;
    };

    // Schedule every cue from timeline second `from` onward.
    Sfx.prototype.schedule = function (from) {
      if (!this.on || !this.ctx) return;
      this.stop();
      var c = this.ctx;
      var t0 = c.currentTime + 0.05;
      var self = this;
      function at(t) {
        return t0 + Math.max(0, t - from);
      }

      // soft rolling rumble that follows the queue's speed
      if (from < 10.8) {
        var rum = this.noise(true);
        var lp = c.createBiquadFilter();
        lp.type = 'lowpass';
        lp.frequency.value = 240;
        var rg = c.createGain();
        rg.gain.setValueAtTime(0, t0);
        [[0.3, 0], [1.2, 0.05], [3, 0.09], [4.7, 0.13], [6.4, 0.13], [9, 0.06], [10.8, 0]].forEach(function (pt) {
          if (pt[0] >= from) rg.gain.linearRampToValueAtTime(pt[1], at(pt[0]));
        });
        rum.connect(lp).connect(rg).connect(this.master);
        rum.start(t0);
        rum.stop(at(10.9));
      }

      function whoosh(t, dur) {
        if (t < from) return;
        var n = self.noise(false);
        var bp = c.createBiquadFilter();
        bp.type = 'bandpass';
        bp.Q.value = 1.1;
        bp.frequency.setValueAtTime(300, at(t));
        bp.frequency.exponentialRampToValueAtTime(2800, at(t + dur));
        var g = c.createGain();
        g.gain.setValueAtTime(0.0001, at(t));
        g.gain.linearRampToValueAtTime(0.16, at(t + dur * 0.45));
        g.gain.exponentialRampToValueAtTime(0.0001, at(t + dur));
        n.connect(bp).connect(g).connect(self.master);
        n.start(at(t));
        n.stop(at(t + dur + 0.1));
      }

      function sprinkle(t) {
        if (t < from) return;
        for (var k = 0; k < 6; k++) {
          var n = self.noise(false);
          var hp = c.createBiquadFilter();
          hp.type = 'highpass';
          hp.frequency.value = 3600 + k * 300;
          var g = c.createGain();
          var s = at(t + k * 0.045);
          g.gain.setValueAtTime(0.0001, s);
          g.gain.linearRampToValueAtTime(0.05, s + 0.01);
          g.gain.exponentialRampToValueAtTime(0.0001, s + 0.16);
          n.connect(hp).connect(g).connect(self.master);
          n.start(s);
          n.stop(s + 0.2);
        }
      }

      function tone(type, freq, t, dur, vol, attack) {
        if (t < from) return;
        var o = self.osc(type, freq);
        var g = c.createGain();
        g.gain.setValueAtTime(0.0001, at(t));
        g.gain.linearRampToValueAtTime(vol, at(t + attack));
        g.gain.exponentialRampToValueAtTime(0.0001, at(t + dur));
        o.connect(g).connect(self.master);
        o.start(at(t));
        o.stop(at(t + dur + 0.1));
      }

      whoosh(0.15, 1.1);
      sprinkle(0.5);
      sprinkle(3.0);
      sprinkle(4.7);
      sprinkle(6.4);
      whoosh(7.7, 1);
      whoosh(11.8, 1);

      // elegant musical finish
      [523.25, 659.25, 783.99, 1046.5].forEach(function (f, i) {
        tone('triangle', f, 12.3 + i * 0.07, 2.6, 0.07, 0.03);
      });
      tone('sine', 261.63, 12.3, 3, 0.06, 0.2);
      [1568, 2093, 2637].forEach(function (f, i) {
        tone('sine', f, 14.15 + i * 0.09, 0.9, 0.018, 0.02);
      });
    };

    /* ---------- the custom element ---------- */

    class LadduMotion extends HTMLElement {
      connectedCallback() {
        if (this._booted) return;
        this._booted = true;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._start.bind(this), { once: true });
        } else {
          this._start();
        }
      }

      disconnectedCallback() {
        this._booted = false;
        this._started = false;
        cancelAnimationFrame(this._raf);
        this._raf = 0;
        if (this._ro) this._ro.disconnect();
        if (this._io) this._io.disconnect();
        if (this._onVis) document.removeEventListener('visibilitychange', this._onVis);
        if (this.sfx) this.sfx.disable();
      }

      _start() {
        if (this._started || !this.isConnected) return;
        this._started = true;

        var self = this;
        this.uid = (this.dataset.uid || 'x').replace(/[^a-zA-Z0-9_-]/g, '');
        this.loop = this.dataset.loop !== 'false';
        this.reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

        this.q = function (k) {
          return self.querySelector('[data-hl="' + k + '"]');
        };
        this.el = {
          bg: this.q('bg'),
          world: this.q('world'),
          platform: this.q('platform'),
          dust: this.q('dust'),
          laddus: this.q('laddus'),
          parts: this.q('parts'),
          sweep: this.q('sweep'),
          glow: this.q('glow'),
          name: this.q('name'),
          tag: this.q('tag'),
          sub: this.q('sub'),
          fade: this.q('fade'),
          sound: this.q('sound')
        };

        this._build();
        this.t = this.reduce ? DURATION : 0;
        this.clock = 0;
        this.visible = true;

        this._layout();
        this._ro = new ResizeObserver(function () {
          self._layout();
          self.render(self.t);
        });
        this._ro.observe(this);

        this._io = new IntersectionObserver(
          function (entries) {
            self.visible = entries[0].isIntersecting;
            self._sync();
          },
          { threshold: 0.05 }
        );
        this._io.observe(this);

        this._onVis = function () {
          self._sync();
        };
        document.addEventListener('visibilitychange', this._onVis);

        this._setupSound();
        this.render(this.t);
        this._sync();
      }

      /* Build laddus, ingredient particles and gold dust once. */
      _build() {
        var uid = this.uid;
        var u0 = 8; // provisional pixel unit; _layout() sets real sizes via CSS --u
        this.laddus = VARIETIES.map(function (v, i) {
          var el = document.createElement('div');
          el.className = 'hl-laddu hl-laddu--' + v.id;
          var ball = document.createElement('div');
          ball.className = 'hl-ball';
          var spin = document.createElement('div');
          spin.className = 'hl-spin';
          spin.innerHTML = sphereSVG(v, uid, i);
          ball.appendChild(spin);
          el.appendChild(ball);
          return { el: el, spin: spin, v: v };
        });
        var host = this.el.laddus;
        this.laddus.forEach(function (L) {
          host.appendChild(L.el);
        });

        // ingredient particles that swirl around each laddu
        var partsHost = this.el.parts;
        this.parts = [];
        this.laddus.forEach(function (L, i) {
          var r = rng(311 * (i + 5));
          var pd = L.v.particle;
          for (var k = 0; k < pd.n; k++) {
            var p = document.createElement('i');
            p.className = 'hp ' + pd.cls;
            if (pd.colors.length) p.style.background = pick(r, pd.colors);
            partsHost.appendChild(p);
            this.parts.push({
              el: p,
              laddu: i,
              idx: k,
              a: r() * TAU,
              rr: 1.22 + r() * 0.5,
              w: (0.45 + r() * 0.75) * (r() < 0.5 ? -1 : 1),
              bob: r() * TAU,
              rot: r() * 360,
              rv: (r() < 0.5 ? -1 : 1) * (40 + r() * 140),
              sz: 0.7 + r() * 0.7
            });
          }
        }, this);

        // drifting gold dust
        var dustHost = this.el.dust;
        var rd = rng(2024);
        this.dust = [];
        for (var d = 0; d < 46; d++) {
          var s = document.createElement('i');
          dustHost.appendChild(s);
          this.dust.push({
            el: s,
            fx: rd(),
            fy: rd(),
            size: 0.3 + rd() * 0.75,
            speed: 0.5 + rd() * 1.5,
            ph: rd() * TAU,
            tw: 0.6 + rd() * 1.2
          });
        }
        void u0;
      }

      /* Size everything from the hero's own box. 1u = 1% of a 16:9 frame. */
      _layout() {
        var W = this.clientWidth || 1;
        var H = this.clientHeight || 1;
        var u = Math.min(W / 100, H / 56.25);
        this.W = W;
        this.H = H;
        this.u = u;
        this.style.setProperty('--u', u.toFixed(3) + 'px');

        this.R = 7 * u; // laddu radius
        this.SP = 19 * u; // centre-to-centre spacing: 5u of clear air between laddus
        this.cx = W / 2;
        this.cy = H / 2 - 6 * u;

        var self = this;
        this.endX = [0, 1, 2, 3].map(function (i) {
          return self.cx + (i - 1.5) * self.SP;
        });
        // distance the queue travels: starts just off the right edge, ends centred on the platform
        this.D = W + this.R + 2 * u - this.endX[0];

        // progress at which each laddu crosses the right edge, pinned to the story beats
        var D = this.D;
        var enter = function (i) {
          return 1 - (W + self.R - self.endX[i]) / D;
        };
        this.pf = makeSpline([
          [0, 0],
          [0.4, Math.max(0.004, enter(0))],
          [3.0, enter(1)],
          [4.7, enter(2)],
          [6.4, enter(3)],
          [10.8, 1]
        ]);
      }

      _sync() {
        var run = this.visible && !document.hidden && !this.reduce;
        if (run && !this._raf) {
          this._last = performance.now();
          this._raf = requestAnimationFrame(this._tick.bind(this));
          if (this.sfx) this.sfx.suspend(false);
        } else if (!run && this._raf) {
          cancelAnimationFrame(this._raf);
          this._raf = 0;
          if (this.sfx) this.sfx.suspend(true);
        }
      }

      _tick(now) {
        var dt = Math.min(0.1, (now - this._last) / 1000);
        this._last = now;
        this.clock += dt;
        this.t += dt;

        if (this.t >= CYCLE) {
          if (this.loop) {
            this.t = 0;
            if (this.sfx) this.sfx.schedule(0);
          } else {
            this.t = DURATION;
          }
        }
        if (!this.loop && this.t > DURATION) this.t = DURATION;

        this.render(this.t);
        this._raf = requestAnimationFrame(this._tick.bind(this));
      }

      _setupSound() {
        var self = this;
        var btn = this.el.sound;
        if (!btn) return;
        this.sfx = new Sfx();
        btn.addEventListener('click', function () {
          var turningOn = btn.getAttribute('aria-pressed') !== 'true';
          if (turningOn) {
            self.sfx.enable().then(function (ok) {
              if (!ok) return;
              btn.setAttribute('aria-pressed', 'true');
              btn.setAttribute('aria-label', 'Turn sound off');
              self.sfx.schedule(Math.min(self.t, DURATION));
            });
          } else {
            self.sfx.disable();
            btn.setAttribute('aria-pressed', 'false');
            btn.setAttribute('aria-label', 'Turn sound on');
          }
        });
      }

      /* One function draws the whole film for any moment t (seconds). */
      render(raw) {
        var t = Math.min(raw, DURATION);
        var u = this.u;
        var R = this.R;
        var W = this.W;
        var H = this.H;
        var cx = this.cx;
        var cy = this.cy;
        var D = this.D;
        var el = this.el;

        var p = this.pf(t);
        var dp = (this.pf(Math.min(t + 0.03, DURATION)) - this.pf(Math.max(t - 0.03, 0))) / 0.06;
        var speed = Math.abs(dp) * D; // px per second
        var settle = 1 - smooth(6.2, 10.6, t); // the curved path flattens as the queue settles

        /* Camera: slow glide while rolling (scenes 1 and 2), push-in on the reveal (scene 4). */
        var glide = 0.5 - p;
        var push = smooth(11.4, DURATION, t);
        el.bg.style.transform = 'translate3d(' + f1(glide * 8 * u) + 'px,0,0)';
        el.world.style.transform =
          'translate3d(' + f1(glide * 3 * u) + 'px,' + f1(-push * 1.2 * u) + 'px,0) scale(' + (1 + 0.1 * push).toFixed(4) + ')';

        /* The four laddus: one rigid, evenly spaced queue on one curved path. */
        for (var i = 0; i < this.laddus.length; i++) {
          var L = this.laddus[i];
          var x = this.endX[i] + D * (1 - p);
          var far = clamp((x - cx) / (W / 2), 0, 1.2);
          var y = cy + Math.sin((TAU * (x - cx)) / (W * 0.85)) * 2.2 * u * settle;
          var sc = 1 - 0.06 * far * settle;
          var deg = ((x - (this.endX[i] + D)) / R) * DEG; // rolling without slipping: leftwards = counter-clockwise
          var blur = clamp(speed * 0.0009, 0, 1.4) + far * 1.5 * settle; // motion blur + depth of field
          var glow = 0.2 + (i === 0 ? 0.4 * (1 - smooth(2.2, 4.8, t)) : 0) + 0.22 * smooth(8.6, 10.4, t);

          L.el.style.transform = 'translate3d(' + f1(x - R) + 'px,' + f1(y - R) + 'px,0) scale(' + sc.toFixed(3) + ')';
          L.el.style.filter =
            'blur(' + blur.toFixed(2) + 'px) drop-shadow(0 0 ' + f1(u * 1.8) + 'px rgba(255,190,90,' + glow.toFixed(2) + '))';
          L.spin.style.transform = 'rotate(' + deg.toFixed(2) + 'deg)';
          L.x = x;
          L.y = y;
        }

        /* Ingredient particles swirl around their laddu, then drift gently once it settles. */
        var calm = smooth(7.5, 11, t);
        for (var k = 0; k < this.parts.length; k++) {
          var q = this.parts[k];
          var lad = this.laddus[q.laddu];
          var ang = q.a + q.w * this.clock * (1 - 0.65 * calm);
          var s = Math.sin(ang);
          var px = lad.x + Math.cos(ang) * q.rr * R;
          var py = lad.y + s * q.rr * R * 0.5 - R * 0.12 + Math.sin(this.clock * 0.8 + q.bob) * u * 0.4;
          var depth = s < 0 ? 0.5 : 1;
          var keep = q.idx < 5 ? 1 : 1 - smooth(8, 10, t); // only a few remain for the hero moment
          q.el.style.opacity = (depth * keep).toFixed(2);
          q.el.style.transform =
            'translate3d(' + f1(px) + 'px,' + f1(py) + 'px,0) rotate(' + f1(q.rot + q.rv * this.clock) + 'deg) scale(' + q.sz.toFixed(2) + ')';
        }

        /* Gold dust drifting upward through the spotlights. */
        var intro = smooth(0, 1.2, t);
        for (var d = 0; d < this.dust.length; d++) {
          var m = this.dust[d];
          var dx = m.fx * W + Math.sin(this.clock * 0.3 + m.ph) * u * 1.5;
          var dy = (((m.fy * H - this.clock * m.speed * u) % H) + H) % H;
          var size = m.size * u;
          m.el.style.width = f1(size) + 'px';
          m.el.style.height = f1(size) + 'px';
          m.el.style.opacity = ((0.25 + 0.55 * (0.5 + 0.5 * Math.sin(this.clock * m.tw + m.ph))) * intro).toFixed(2);
          m.el.style.transform = 'translate3d(' + f1(dx) + 'px,' + f1(dy) + 'px,0)';
        }

        /* Display platform rises into place, then a golden light sweep crosses the row. */
        var show = smooth(5.8, 8.2, t);
        el.platform.style.opacity = show.toFixed(3);
        el.platform.style.transform = 'translate3d(0,' + f1((1 - show) * 3 * u) + 'px,0)';

        var sw = smooth(8.8, 11.6, t);
        el.sweep.style.opacity = (Math.sin(Math.PI * sw) * 0.85).toFixed(3);
        el.sweep.firstElementChild.style.transform = 'translateX(' + f1(-130 + 650 * sw) + '%) skewX(-18deg)';

        el.glow.style.opacity = (0.9 * smooth(11.4, 13.2, t)).toFixed(3);

        /* Brand reveal. */
        var a = smooth(12.2, 13.5, t);
        el.name.style.opacity = a.toFixed(3);
        el.name.style.transform = 'translate3d(0,' + f1((1 - a) * 1.6 * u) + 'px,0)';
        el.name.style.filter =
          'blur(' + ((1 - a) * 6).toFixed(2) + 'px) drop-shadow(0 ' + f1(u * 0.3) + 'px ' + f1(u * 1.2) + 'px rgba(255,176,60,.35))';
        el.name.style.setProperty('--shine', f1(120 - 140 * smooth(12.4, DURATION, t)) + '%');

        var b = smooth(13.0, 14.0, t);
        el.tag.style.opacity = b.toFixed(3);
        el.tag.style.transform = 'translate3d(0,' + f1((1 - b) * 1 * u) + 'px,0)';

        var c = smooth(13.8, 14.7, t);
        el.sub.style.opacity = c.toFixed(3);
        el.sub.style.transform = 'translate3d(0,' + f1((1 - c) * 0.8 * u) + 'px,0)';

        /* Loop seam: fade in at the start, fade out after the hold. */
        var fade = 0;
        if (raw < 0.5) fade = this.loop || raw < 0.5 ? 1 - smooth(0, 0.5, raw) : 0;
        if (this.loop && raw > DURATION + HOLD) fade = smooth(DURATION + HOLD, CYCLE, raw);
        if (this.reduce) fade = 0;
        el.fade.style.opacity = fade.toFixed(3);
      }
    }

    customElements.define('laddu-motion', LadduMotion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
